export default __webpack_public_path__ + "static/media/iqro.23b10c27.png";